import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { QueryStatus } from 'services/types';

import { selectDataDashboard } from 'containers/Visibility/Data/selectors';
import { actions } from 'containers/Visibility/Data/slice';

export const useDataTypeClassifiers = () => {
  const dispatch = useDispatch();
  const { dataClassifiers } = useSelector(selectDataDashboard);

  useEffect(() => {
    if (dataClassifiers.status === QueryStatus.uninitialized) {
      dispatch(actions.getDataClassifiers({}));
    }
  }, [dataClassifiers.status, dispatch]);

  return {
    classifiers: dataClassifiers.data,
    isLoading: dataClassifiers.isLoading,
  };
};
